import {IconButton, InputAdornment, useTheme} from "@mui/material";
import React from "react";
import {View, ViewOff} from "@carbon/icons-react";

interface VisibilityToggleProps {
    onClick: (event: React.MouseEvent<HTMLElement>) => void,
    showText: boolean
}

export const PasswordVisibilityToggle = ({onClick, showText}: VisibilityToggleProps) => {
    const theme = useTheme()
    return (
        <InputAdornment position="end">
            <IconButton className="eye-button" onClick={onClick} edge="end">
                {showText ? <View size={24} /> : <ViewOff size={24} />}
            </IconButton>
        </InputAdornment>
    );
}